export interface ICreateBatch {
  productId: number;
  storeId: number;
  enteredQuantity: number;
  batchNumber?: string;
  expirationDate: string;
  storableType: number;
  storableId: number;
  notes?: string;
}

export interface ITransferBatch {
  storableType: number;
  storableId: number;
  reason?: string;
}

export interface IUpdateBatch {
  enteredQuantity?: number;
  batchNumber?: string;
  expirationDate?: string;
  notes?: string;
}

export enum BatchWriteOffReason {
  BALANCE_DISCREPANCY = 1,
  WASTE = 2,
  SHRINKAGE_EXPENSE = 3,
  WRITE_OFF = 4,
  EXPIRY = 5,
}

export interface IWriteOffBatch {
  quantity: number;
  reason: BatchWriteOffReason | number;
  notes?: string;
}
